<ion-card
  *ngIf="
    !!orderItem &&
      hasCriticalError &&
      (!showSubstitute ||
        (showSubstitute && substituteReplacementAvailability > 0));
    else validOrderItem
  "
  class="usf-product-card_wrapper product-header-exception"
  [class.is-mobile]="platformService?.platformType === platformEnum.mobile"
>
  <!--ERROR HEADER AND QUANTITY EXCEPTIONS-->
  <ng-container *ngIf="!!orderHeaderErrorMsg || !!orderItem.orderItemErrorMsg">
    <div class="error-message_text">
      <ion-icon
        name="alert-circle-outline"
        class="error-message_icon"
      ></ion-icon>
      <ion-label class="break">
        <p>{{ orderHeaderErrorMsg || orderItem.orderItemErrorMsg }}</p>
        <ng-container *appShowSplit="[showViewSubsLink]">
          <a
            *ngIf="
              !orderHeaderErrorCode &&
              !showSubstitute &&
              substituteReplacementAvailability === 0
            "
            class="green-link"
            (click)="getSubstitute()"
          >
            {{
              (orderItem.subOrReplacementProduct.substituteType !==
              SubstituteTypeEnum.REPLACEMENT
                ? 'i18n.importOrderPage.substituteLinkProduct'
                : 'i18n.importOrderPage.replacementLinkProduct'
              ) | translate
            }}
          </a>
          <span
            *ngIf="
              !orderHeaderErrorCode &&
              (showSubstitute ||
                (!showSubstitute && substituteReplacementAvailability === 1))
            "
            class="no-substitute"
            >&nbsp;
            {{
              (orderItem.orderItemErrorCode !==
              ErrorTypeEnum.CRITICAL_ERROR_1003
                ? 'i18n.importOrderPage.substituteProductNoAvailable'
                : 'i18n.importOrderPage.replacementProductNoAvailable'
              ) | translate
            }}
          </span>
        </ng-container>
      </ion-label>
    </div>

    <div class="usf-product-card_content">
      <div class="usf-product-card_text">
        <div class="product-info">
          <div class="brand">{{ orderItem.brand }}</div>
          <div class="description">{{ orderItem.productDesc }}</div>
          <div class="other-product-info">
            #{{ orderItem.productNumber }}
            <span *ngIf="!!orderItem.packSize" class="mini-border">|</span>
            {{ orderItem.packSize }}
          </div>
          <div class="usf-product-card_units">
            <span> {{ orderItem.unitsOrdered }} CS</span>
            <span *ngIf="orderItem.breakable" class="mini-border">|</span>
            <span *ngIf="orderItem.breakable"
              >{{ orderItem.eachesOrdered }} EA</span
            >
          </div>
          <div class="usf-product-card_tags">
            <app-usf-chip
              *ngIf="orderItem.directEligible"
              [type]="vendorDirectTag.type"
              [clickable]="vendorDirectTag.clickable"
              [iconConfig]="vendorDirectTag.iconConfig"
              [iconUrl]="vendorDirectTag.iconUrl"
            ></app-usf-chip>
            <app-usf-chip *ngIf="orderItem.mslIndicator">
              {{ 'i18n.productDetail.status.onMasterList' | translate }}
            </app-usf-chip>
            <app-usf-chip *ngIf="orderItem.locallySourceIndicator">
              {{ 'i18n.productDetail.status.locallySource' | translate }}
            </app-usf-chip>
            <app-usf-chip
              *ngIf="contractTag"
              [type]="contractTag.type"
              [iconConfig]="contractTag.iconConfig"
              [iconUrl]="contractTag.iconUrl"
            >
            </app-usf-chip>
          </div>
        </div>
        <div>
          <ion-icon
            *ngIf="(platformService?.isTouchExperience$ | async) === true"
            name="close-circle"
            class="icon_close-product"
            (click)="remove()"
          >
          </ion-icon>
        </div>
      </div>

      <div class="usf-product-card_quantities">
        <ion-icon
          *ngIf="(platformService?.isTouchExperience$ | async) === false"
          name="close-circle"
          class="icon_close-product icon_close-product-sm"
          (click)="remove()"
        >
        </ion-icon>
      </div>
    </div>
  </ng-container>
</ion-card>

<ng-template #validOrderItem>
  <ion-card
    *ngIf="
      !hasCriticalError &&
        !!orderItem &&
        (!showSubstitute ||
          (showSubstitute && substituteReplacementAvailability > 0));
      else substituteSplitCard
    "
    class="usf-product-card_wrapper valid-product"
    [class.is-touch]="platformService?.isTouchExperience$ | async"
  >
    <div class="warning-message" *ngIf="hasMinorError">
      <ion-icon name="alert-circle-outline" class="icon_alert-info"></ion-icon>

      <ion-label
        [class.break]="
          !orderHeaderErrorCode &&
          (showSubstitute ||
            (!showSubstitute && substituteReplacementAvailability > -1))
        "
      >
        <p>&nbsp;{{ orderItem.orderItemErrorMsg || orderHeaderErrorMsg }}</p>
        <ng-container *appShowSplit="[showViewSubsLink]">
          <a
            *ngIf="
              !orderHeaderErrorCode &&
              !showSubstitute &&
              substituteReplacementAvailability === 0
            "
            class="green-link"
            (click)="getSubstitute()"
          >
            {{ 'i18n.importOrderPage.substituteLinkProduct' | translate }}
          </a>
          <span
            *ngIf="
              !orderHeaderErrorCode &&
              (showSubstitute ||
                (!showSubstitute && substituteReplacementAvailability === 1))
            "
            class="no-substitute"
            >&nbsp;
            {{
              'i18n.importOrderPage.substituteProductNoAvailable' | translate
            }}
          </span>
        </ng-container>
      </ion-label>
    </div>

    <div class="usf-product-card_content">
      <div class="product-info">
        <div class="brand">{{ orderItem.brand }}</div>
        <div class="description">{{ orderItem.productDesc }}</div>
        <div class="other-product-info">
          #{{ orderItem.productNumber }}
          <span *ngIf="!!orderItem.packSize" class="mini-border">|</span>
          {{ orderItem.packSize }}
        </div>
        <div class="usf-product-info-quantity">
          <span>{{ orderItem.unitsOrdered }} CS</span>
          <br *ngIf="orderItem.breakable" class="hide" />
          <span *ngIf="orderItem.breakable" class="mini-border">|</span>
          <span *ngIf="orderItem.breakable"
            >{{ orderItem.eachesOrdered }} EA</span
          >
        </div>
        <div class="usf-product-card_tags">
          <app-usf-chip
            *ngIf="orderItem.directEligible"
            [type]="vendorDirectTag.type"
            [clickable]="vendorDirectTag.clickable"
            [iconConfig]="vendorDirectTag.iconConfig"
            [iconUrl]="vendorDirectTag.iconUrl"
          ></app-usf-chip>
          <app-usf-chip *ngIf="orderItem.mslIndicator">
            {{ 'i18n.productDetail.status.onMasterList' | translate }}
          </app-usf-chip>
          <app-usf-chip *ngIf="orderItem.locallySourceIndicator">
            {{ 'i18n.productDetail.status.locallySource' | translate }}
          </app-usf-chip>
          <app-usf-chip
            *ngIf="contractTag"
            [type]="contractTag.type"
            [iconConfig]="contractTag.iconConfig"
            [iconUrl]="contractTag.iconUrl"
          >
          </app-usf-chip>
        </div>
      </div>
    </div>
    <div class="usf-product-info">
      <!-- QUANTITIES FIELDS -->
      <!-- <div class="usf-product-info-quantity-boxes">
        <div class="usf-product-card-quantity-section">
          <app-quantity-input
            [productNumber]="orderItem.productNumber"
            [isDisabled]="false"
            [isEaches]="false"
            [platform]="platformService.platformType"
            [quantity]="unitsOrdered"
            [isProductCard]="true"
            (quantityUpdateEmitter)="changeQuantityHandler($event)"
          ></app-quantity-input>
          <span class="usf-product-card-text-section">CS</span>
        </div>
        <div class="usf-product-card-quantity-section">
          <app-quantity-input
            [productNumber]="orderItem.productNumber"
            [isDisabled]="false"
            [isEaches]="true"
            [platform]="platformService.platformType"
            [quantity]="eachesOrdered"
            [isProductCard]="true"
            (quantityUpdateEmitter)="changeQuantityHandler($event)"
          ></app-quantity-input>
          <span class="usf-product-card-text-section">EA</span>
        </div>
      </div> -->
      <ion-icon
        [class.shift-up]="!hasMinorError"
        name="close-circle"
        class="icon-close"
        (click)="remove()"
      ></ion-icon>
    </div>
  </ion-card>
</ng-template>

<ng-template #substituteSplitCard>
  <app-import-order-validation-split-product
    *ngIf="!!orderItem?.subOrReplacementProduct"
    [orderItem]="orderItem"
    [orderHeaderErrorMsg]="orderHeaderErrorMsg"
    [orderHeaderErrorCode]="orderHeaderErrorCode"
    [vendorDirectTag]="vendorDirectTag"
    [contractTag]="contractTag"
    [unitsOrdered]="unitsOrdered"
    [eachesOrdered]="eachesOrdered"
    [disabledQuantities]="false"
    (removeEmitter)="remove()"
    (quantityEmitter)="changeQuantityHandler($event)"
    (replaceEmitter)="acceptReplaceSubstitute($event)"
  >
  </app-import-order-validation-split-product>
</ng-template>
